import $ from 'jquery';

export function bringModalToFront(
  selector,
  { onModalDismissed = () => {}, onModalShown = () => {} } = {}
) {
  const modalWindow = $(selector);

  modalWindow.on('hidden.bs.modal', function handleModalDismissed() {
    modalWindow.css({ zIndex: '' });
    modalWindow.off('hidden.bs.modal', handleModalDismissed);
    $('.modal-backdrop').last().css({ zIndex: '' });

    onModalDismissed && onModalDismissed();
  });

  modalWindow.on('show.bs.modal', function bringToFront() {
    modalWindow.css({ zIndex: 65536 });
    // The backdrop only appears once the modal starts to appear.
    setTimeout(() => {
      $('.modal-backdrop').last().css({ zIndex: 65535 });
    }, 0);
    onModalShown && onModalShown();
    modalWindow.off('show.bs.modal', bringToFront);
  });
}
